import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@styled-icons/boxicons-regular/ArrowBack';
import { IconBack, BCGridItem } from './styles/Banner.styles';
import FormHOC from './components/Form/FormHOC';
import Form from './components/Form/Form';
import { useBanner } from './services/Banner.hooks';
import Loader from '@/components/Routes/Loader';

export default function Banner() {
  const { bannerId } = useParams();
  const { bannerToShow } = useBanner({ id: bannerId });
  const navigate = useNavigate();
  const handleClickBack = () => navigate('/promo-manager/banners/');

  if (!bannerToShow && bannerId) return <Loader />;

  return (
    <>
      <BCGridItem bg="transparent" boxShadow="none" p="0" area={'header'}>
        <Flex alignItems="center">
          <IconBack as={ArrowBack} onClick={handleClickBack} />
          {bannerToShow?.title}
        </Flex>
      </BCGridItem>
      <FormHOC>
        <Form banner={bannerToShow ?? undefined} />
      </FormHOC>
    </>
  );
}
